import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ApplicantList from "../components/ApplicantList";

const ApplicanListPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='Applicant List' />

                <ApplicantList />

            </MasterLayout>
        </>
    );
};

export default ApplicanListPage;
